// ═══════════════════════════════════════════════════════════════
//  versPlanning.js — « Mettre au planning » depuis une tâche (lot T11)
//
//  ⚠️ CE FICHIER N'IMPORTE RIEN, ET C'EST VOLONTAIRE — même parti pris que
//  workflow.js, affectation.js et tacheSms.js : versPlanning.test.js
//  l'importe POUR DE VRAI en `node` pur. Une logique qu'un test doit
//  recopier n'est pas testée.
//
//  Sens INVERSE du lot T5 (planning → tâche) ; les deux gestes écrivent
//  EXACTEMENT la même chose : une ligne de `planningCreneaux.taches[]`
//  portant `tacheRefId`. Lien à SENS UNIQUE, porté par le créneau seul :
//  rien n'est jamais écrit sur le document `taches` (décision T5, expliquée
//  en tête d'AffectationModal.jsx).
//
//  🔴 LE RISQUE DE CE LOT : l'id d'un créneau affecté est DÉTERMINISTE
//  (`{ressourceId}_{date}_{periode}`). Écrire la seule ligne nouvelle
//  REMPLACERAIT la demi-journée déjà planifiée d'un monteur, en silence
//  (un tableau n'est jamais fusionné par `merge:true`, il est remplacé).
//  D'où `fusionnerLignes` : on AJOUTE aux lignes existantes, jamais on ne
//  les remplace.
// ═══════════════════════════════════════════════════════════════

// Rôles autorisés à écrire un créneau — CALQUE EXACT de la rule
// `planningCreneaux` (create/update/delete : isAdmin() || isAssistante() ||
// isConducteur() || role() == "Chef chantier" ; isAssistante() et
// isConducteur() couvrent Direction). Toute divergence produit un bouton qui
// échoue en permission-denied. versPlanning.test.js relit firestore.rules et
// échoue si les deux listes se séparent.
export const ROLES_PLANIFICATEURS = [
  "Admin", "Direction", "Assistante", "Conducteur travaux", "Chef chantier",
];

// `role` = rôle PRINCIPAL (roles[0]) = le claim `request.auth.token.role`
// que lit la rule. Comparaison exacte, casse comprise, comme la rule.
export function peutPlanifier(role) {
  return typeof role === "string" && ROLES_PLANIFICATEURS.includes(role);
}

// Ligne de créneau construite depuis la tâche. Le TITRE devient `posteLabel` :
// c'est lui qui s'affiche dans la barre du planning et dans le SMS de planning
// du monteur (planningSms lit posteLabel). Pas de bâtiment ni de poste : une
// tâche n'est pas une case d'avancement. `tempsEstimeH: null` = durée de la
// demi-journée (défaut appliqué au miroir par affectedCreneauPayload).
// `faireId` est injecté (makeTacheId de planningModel) pour rester sans import.
export function ligneDepuisTache(tache, faireId) {
  const titre = typeof tache?.titre === "string" ? tache.titre.trim() : "";
  const chantierId = tache?.chantierId != null && tache.chantierId !== ""
    ? String(tache.chantierId)
    : null;
  return {
    id: faireId(),
    chantierId,
    batiment: null,
    posteAvancementKey: null,
    posteLabel: titre || null,
    tempsEstimeH: null,
    tacheRefId: tache?.id || null,
  };
}

// Fusion SÛRE : les lignes existantes, INTACTES et dans leur ordre, puis la
// nouvelle à la fin. Si la tâche est DÉJÀ sur ce créneau (même tacheRefId),
// rien n'est ajouté et `deja` le dit — on ne planifie pas deux fois la même
// tâche sur la même demi-journée. Ne mute jamais le tableau reçu.
export function fusionnerLignes(lignesExistantes, nouvelleLigne) {
  const lignes = Array.isArray(lignesExistantes) ? lignesExistantes.filter(Boolean) : [];
  const ref = nouvelleLigne?.tacheRefId || null;
  if (ref && lignes.some((l) => l.tacheRefId === ref)) {
    return { lignes: [...lignes], deja: true };
  }
  return { lignes: [...lignes, nouvelleLigne], deja: false };
}
